module.exports = __webpack_public_path__ + "static/under-1-hr-img-43d877f76b83461dc1eff9a00e6038f1.png";